<template>
  <v-layout justify-center>
    <v-dialog v-model="currentAlert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Job already in progress</v-card-title>
        <v-card-text>There is already a job in progress, by creating a new job you will lose any progress. Are you sure
          you want discard the current job?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="discardCurrentJob">Discard</v-btn>
          <v-btn color="green darken-1" flat to="/CurrentJob">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-flex xs-12>
        <v-card>
          <v-container>
            <v-form v-model="valid" ref="form" lazy-validation>
              <!-- <v-text-field
          label="Customer"
          v-model="currentJob.customer"
          :rules="customerRules"
          required
        ></v-text-field> -->
              <v-autocomplete label="Customer" v-model="currentJob.Customer" :items="customers" item-text="name"
                item-value="id" required no-data-text="No Results - Please type at least 3 characters"
                :rules="customerRules" :search-input.sync="customerFilter" :loading="customerLoading"></v-autocomplete>
              <v-combobox label="Vehicle Registration" v-model="currentJob.Vehicle" :items="vehicles"
                item-text="VehicleReg" item-value="VehicleReg" :return-object="false" required :rules="vehicleRules">
              </v-combobox>
              <v-text-field label="IMEI Number" v-model="currentJob.imei" type="number"></v-text-field>
              <v-divider></v-divider>
              <v-subheader>Checklists required</v-subheader>
              <v-checkbox v-for="(item, index) in templates" v-bind:key="index" :label="item.name"
                v-model="item.required" :disabled="!item.optional"></v-checkbox>
              <v-btn @click="createJob" :disabled="!valid" block color="success" :loading="creating">
                Create Job
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
      <v-dialog v-model="duplicateDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Job already in system</v-card-title>
          <v-card-text>A job for this vehicle is already present in the system. Do you want use the orriginal or
            continue to create a new job?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="confirmAndCreate">Create New</v-btn>
            <v-btn color="green darken-1" flat @click="createFromOGJob">Keep Original</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <disclaimer-dialog :dialog.sync="disclaimerDialog"></disclaimer-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import { fireStore } from '../firebase'
import dbPromise from '../dbPromise'
import moment from 'moment'
export default {
  data () {
    return {
      currentAlert: false,
      templates: [],
      customerFilter: '',
      currentJob: {
        Customer: '',
        Vehicle: '',
        Date: '',
        imei: ''
      },
      valid: false,
      customerRules: [
        (v) => !!v && v.length > 0 || 'Customer is required'
      ],
      vehicleRules: [
        (v) => !!v || 'Vehicle Registration is required'
      ],
      creating: false,
      user: this.$store.getters.user,
      disclaimerDialog: false,
      customerLoading: false,
      duplicateDialog: false,
      activeJob: null,
      confirmCreate: false
    }
  },
  mounted () {
    this.currentJob.Date = moment().format('YYYY-MM-DD')
    dbPromise().then((db) => {
      let tx = db.transaction('currentJob')
      let currentStore = tx.objectStore('currentJob')
      return (currentStore.getAll())
    }).then((val) => {
      if (val.length > 0) {
        this.currentJob = val[0]
        this.currentAlert = true
      } else {
        this.currentAlert = false
        this.disclaimerDialog = true
      }
    })
    dbPromise().then((db) => {
      let tx = db.transaction('templates')
      let templateStore = tx.objectStore('templates')
      return (templateStore.getAll())
    }).then((val) => {
      console.log(val)
      this.templates = []
      if (val.length > 0) {
        val.forEach(template => {
          this.templates.push(template)
        })
      }
      this.templates.sort((a, b) => {
        return a.Index - b.Index
      })
    })
  },
  watch: {
    'currentJob.Vehicle' (val) {
      if (val) {
        val = val.toUpperCase().replace(/\s/g, '')
        this.customerLoading = true
        setTimeout(() => {
          this.customerLoading = false
        }, 2000)
        fireStore.collection('Vehicles').where('VehicleReg', '==', val).get()
          .then(snap => {
            snap.forEach(doc => {
              console.log(doc.data().Customer)
              this.currentJob.Customer = doc.data().Customer
            })
          })
      }
    }
  },
  methods: {
    createFromOGJob () {
      fireStore.collection('Jobs').doc(this.activeJob.number).update({ jobStarted: moment().format('x'), Allocated: this.user.id })
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.put({
          Customer: this.activeJob.Customer,
          number: this.activeJob.number,
          reg: this.activeJob.vehReg,
          JobNo: this.activeJob.JobNo,
          imei: this.activeJob.imei,
          vehicle: this.activeJob.Vehicle,
          newMethod: this.activeJob.newMethod,
          jobLookupIds: this.activeJob.jobLookupIds,
          startTime: moment().format('x'),
          notes: this.activeJob.notes || '',
          chargeable: false,
          CreatedDate: Date.now()
        }, 0)
        return tx.complete
      }).then(() => {
        let templates = []
        this.templates.forEach(template => {
          console.log(template.id)
          console.log(this.activeJob.templates)
          if (this.activeJob.templates.indexOf(template.id) !== -1) {
            templates.push(template)
          }
        })
        dbPromise().then((db) => {
          let tx = db.transaction('currentJob', 'readwrite')
          let currentStore = tx.objectStore('currentJob')
          currentStore.put(templates, 1)
          return tx.complete
        }).then(() => {
          this.$router.push('/CurrentJob')
        })
      })
    },
    confirmAndCreate () {
      this.confirmCreate = true
      this.createJob()
    },
    async createJob () {
      if (this.$refs.form.validate()) {
        this.creating = true
        const vehicleExists = this.vehicles.find(vehicle => {
          return this.currentJob.Vehicle === vehicle.VehicleReg || JSON.stringify(this.currentJob.Vehicle) === JSON.stringify(vehicle) || this.currentJob.vehicle === vehicle.id
        })
        if (!this.confirmCreate && vehicleExists) {
          let jobData = await fireStore.collection('Jobs').where('Vehicle', '==', vehicleExists.id).where('Status', '<=', 0).get()
          this.activeJob = null
          if (!jobData.empty) {
            this.activeJob = jobData.docs[0].data()
            this.activeJob.number = jobData.docs[0].id
          }
          if (this.activeJob) {
            this.duplicateDialog = true
            return
          }
        }

        let promise = new Promise((resolve, reject) => {
          if (!vehicleExists) {
            fireStore.collection('Vehicles').add({ VehicleReg: this.currentJob.Vehicle, Customer: this.currentJob.Customer })
              .then(docRef => {
                this.$store.dispatch('addVehicle', {
                  Customer: this.currentJob.Customer,
                  VehicleReg: this.currentJob.Vehicle.toUpperCase().replace(/\s/g, ''),
                  id: docRef.id
                })
                this.currentJob.reg = this.currentJob.Vehicle
                this.currentJob.Vehicle = docRef.id
                resolve()
              })
          } else {
            this.currentJob.reg = vehicleExists.VehicleReg
            this.currentJob.Vehicle = vehicleExists.id
            resolve()
          }
        })

        let docRef = await fireStore.collection('Projects').where('Customer', '==', this.currentJob.Customer).get()
        const customerIndex = this.customers.findIndex(customerListObj => {
          return customerListObj.id === this.currentJob.Customer
        })
        const shortName = this.customers[customerIndex]['shortName']
        let projectIds = []
        let projectId = ''
        docRef.forEach(doc => {
          let projId = doc.data().projectId
          if (projId) {
            projId = projId.replace(/\D/g, '')
            projectIds.push(projId)
          }
        })
        projectIds = projectIds.sort()
        projectIds = projectIds.reverse()
        if (projectIds.length === 0) {
          projectIds.push(0)
        }
        projectId = projectIds[0]
        projectId = 'EC-' + shortName + this.zeroFill(parseInt(projectId) + 1, 4)
        let dataToSend = { jobType: 'Service Call', CreatedDate: moment().format('YYYY-MM-DD'), supplierPO: null, supplierCost: null, customerPO: null, customerCost: null, Customer: this.currentJob.Customer, projectId: projectId, Status: 'Install In Progress', notes: 'Created by engineer on app.' }
        let response = await fireStore.collection('Projects').add(dataToSend)

        console.log(response)

        let promise2 = new Promise((resolve, reject) => {
          let jobNumbers = [0]
          const customerIndex = this.customers.findIndex(customer => {
            return this.currentJob.Customer === customer.id
          })
          const shortName = this.customers[customerIndex]['shortName']
          fireStore.collection('Jobs').where('Customer', '==', this.currentJob.Customer).get()
            .then(snap => {
              snap.forEach(doc => {
                let JobNo = doc.data().JobNo
                if (JobNo && JobNo.indexOf(shortName) > -1) { // This check is needed in case the short name has been changed. We only want to increment on job numbers with the new short name.
                  JobNo = JobNo.replace(/\D/g, '')
                  jobNumbers.push(JobNo)
                }
              })
              jobNumbers.sort((a, b) => {
                return b - a
              })
              console.log(jobNumbers)
              this.currentJob.JobNo = shortName + this.zeroFill(parseInt(jobNumbers[0]) + 1, 4)
              resolve()
            })
            .catch(error => {
              reject(error)
            })
        })
        Promise.all([promise, promise2]).then((values) => {
          console.log(this.currentJob)
          this.currentJob.unscheduled = 0
          if (!this.currentJob.Date) {
            this.currentJob.Date = moment().format('YYYY-MM-DD')
          }
          if (this.currentJob.imei === undefined || this.currentJob.imei === null) {
            this.currentJob.imei = ''
          }
          let templates = ['preCheck']
          this.templates.forEach(template => {
            if (template.required && template.id !== 'preCheck') {
              templates.push(template.id)
            }
          })
          if (this.currentJob.templates) {
            templates = this.currentJob.templates
          }
          const jobject = {
            jobLookupIds: this.currentJob.jobLookupIds || [],
            JobNo: this.currentJob.JobNo,
            Customer: this.currentJob.Customer,
            Vehicle: this.currentJob.Vehicle,
            reg: this.currentJob.reg,
            imei: this.currentJob.imei,
            Date: this.currentJob.Date,
            templates: templates,
            unscheduled: this.currentJob.unscheduled,
            Project: projectId,
            Status: -1,
            chargeable: false,
            Allocated: this.user.id,
            Supplier: this.user.company ? this.user.company : '',
            startTime: moment().format('x'),
            CreatedDate: Date.now()
          }
          console.log(jobject)
          fireStore.collection('Jobs').add(jobject)
            .then(docRef => {
              jobject.number = docRef.id
              dbPromise().then((db) => {
                let tx = db.transaction('currentJob', 'readwrite')
                let currentStore = tx.objectStore('currentJob')
                currentStore.put(jobject, 0)
                return tx.complete
              }).then(() => {
                dbPromise().then((db) => {
                  let tx = db.transaction('currentJob', 'readwrite')
                  let currentStore = tx.objectStore('currentJob')
                  let templates = []
                  this.templates.forEach(element => {
                    if (element.required) {
                      templates.push(element)
                    }
                  })
                  currentStore.put(templates, 1)
                  return tx.complete
                }).then(() => {
                  this.creating = false
                  this.$router.push('/CurrentJob')
                })
              })
            })
        })
          .catch(error => {
            console.log(error)
            this.creating = false
          })
      }
    },
    discardCurrentJob () {
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.clear()
        return tx.complete
      }).then(() => {
        this.currentJob = {
          Customer: '',
          Vehicle: '',
          Date: '',
          imei: ''
        }
        this.currentAlert = false
      })
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  },
  computed: {
    customers () {
      if ((!this.customerFilter || this.customerFilter.length < 3) && !this.currentJob.Customer) {
        return []
      }

      return this.$store.getters.customers.filter(a => {
        if (!this.user.customers || this.user.customers.length <= 0) {
          return true
        } else {
          return this.user.customers.indexOf(a.id) !== -1
        }
      }).sort((a, b) => {
        const aName = a.name.toLowerCase()
        const bName = b.name.toLowerCase()
        return aName < bName ? -1 : aName > bName ? 1 : 0
      })
    },
    vehicles () {
      const vehicles = this.$store.getters.vehicles
      let customerVehicles = []
      vehicles.forEach(vehicle => {
        if (vehicle.Customer === this.currentJob.Customer) {
          customerVehicles.push(vehicle)
        }
        if (!vehicle.VehicleReg) {
          vehicle.VehicleReg = vehicle.friendlyId ? vehicle.friendlyId : vehicle.id
        }
      })
      return customerVehicles.sort((a, b) => {
        const aVehReg = a.VehicleReg
        const bVehReg = b.VehicleReg
        if (!aVehReg) {
          return 0
        }
        if (!bVehReg) {
          return 1
        }
        return aVehReg.toLowerCase() < bVehReg.toLowerCase() ? -1 : aVehReg.toLowerCase() > bVehReg.toLowerCase() ? 1 : 0
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// CreateJob.vue?a735a5aa